var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_110",
    "data-name": "Rect\\xE1ngulo 110",
    width: 16.116,
    height: 4.346,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_666",
    "data-name": "Grupo 666",
    transform: "translate(-743 -1095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_23",
    "data-name": "Elipse 23",
    transform: "translate(743 1095)",
    fill: "#545882",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_661",
    "data-name": "Grupo 661",
    transform: "translate(751.905 1109.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_623",
    "data-name": "Grupo 623",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3354",
    "data-name": "Trazado 3354",
    d: "M15.28,4.346H.836A.845.845,0,0,1,0,3.493V.853A.845.845,0,0,1,.836,0H15.28a.845.845,0,0,1,.836.853v2.64a.845.845,0,0,1-.836.853",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDash);
export default __webpack_public_path__ + "static/media/icon-dash.14e03296e35f93b9c8cb6c9e24940218.svg";
export { ForwardRef as ReactComponent };